import productDetails from "./productDetails"
export default productDetails;
